import React from 'react';

import useCallouts from 'hooks/useCallouts.jsx';
import { CircleFlair, IconFlair } from './FlairPrimitives.jsx';

const Flair = ({ id, ...props }) => {
  const { callouts } = useCallouts({ id });

  if (id && callouts.length) {
    // See useCallouts for more details
    const callout = callouts[0];
    if (callout.content) {
      return { ...callout.content, props: { ...callout.content.props, ...props } };
    } else {
      return <CircleFlair {...props} />; // Default flair?
    }
  } else if (typeof props?.name === 'string') {
    // Legacy - requesting flairs without id
    // by Icon name
    return <IconFlair {...props} />;
  } else {
    return null;
  }
};

export { Flair };
